import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faCog,
  faAddressBook,
  faAngleDown,
  faAngleUp,
  faArchive,
  faArrowAltCircleDown,
  faArrowAltCircleRight,
  faArrowAltCircleUp,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faBackspace,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookmark,
  faBox,
  faBriefcase,
  faBuilding,
  faCalculator,
  faCalendarAlt,
  faCaretDown,
  faCaretSquareLeft,
  faCaretUp,
  faChartArea,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClock,
  faCloud,
  faCogs,
  faCoins,
  faCommentDots,
  faCopy,
  faCreditCard,
  faDesktop,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpenText,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpandAlt,
  faExternalLinkAlt,
  faEye,
  faFile,
  faFileAlt,
  faFileInvoice,
  faFileImage,
  faFileInvoiceDollar,
  faFileSignature,
  faFolder,
  faFolderOpen,
  faFileContract,
  faGavel,
  faGripHorizontal,
  faHandshake,
  faHashtag,
  faHdd,
  faHome,
  faIdBadge,
  faImage,
  faIndent,
  faInfoCircle,
  faKey,
  faLanguage,
  faLink,
  faList,
  faListUl,
  faLock,
  faUnlock,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMap,
  faTable,
  faMicrophone,
  faMicrophoneSlash,
  faMinus,
  faMinusCircle,
  faNetworkWired,
  faMobile,
  faMoneyBill,
  faMoneyBillWaveAlt,
  faMoneyCheckAlt,
  faOutdent,
  faPaperPlane,
  faPause,
  faPen,
  faPencilAlt,
  faPeopleArrows,
  faPercentage,
  faPhone,
  faPlay,
  faPlayCircle,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faProjectDiagram,
  faQuestionCircle,
  faReceipt,
  faSearch,
  faShareAlt,
  faSignOutAlt,
  faSlidersH,
  faSave,
  faSpinner,
  faStickyNote,
  faStopCircle,
  faStream,
  faSync,
  faThLarge,
  faTicketAlt,
  faTimes,
  faTimesCircle,
  faTools,
  faTrash,
  faTrashAlt,
  faUndoAlt,
  faUnlink,
  faUpload,
  faFileUpload,
  faFileImport,
  faUser,
  faUserPlus,
  faUsers,
  faUserTie,
  faVideo,
  faVideoSlash,
  faVolumeMute,
  faVolumeUp,
  faEyeSlash,
  faLandmark,
  faFolderMinus,
  faSignature,
  faFilePdf,
  faPaperclip,
  faUndo,
  faMoon,
  faSun
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faStar,
  faCog,
  faArrowDown,
  faExternalLinkAlt,
  faMoneyCheckAlt,
  faEllipsisH,
  faBook,
  faPause,
  faBan,
  faStopCircle,
  faPlay,
  faPlayCircle,
  faVolumeMute,
  faVolumeUp,
  faCaretUp,
  faCaretDown,
  faAddressBook,
  faAngleDown,
  faAngleUp,
  faArchive,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBackspace,
  faBars,
  faBell,
  faBookmark,
  faBox,
  faBriefcase,
  faBuilding,
  faCalendarAlt,
  faCaretSquareLeft,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClock,
  faCloud,
  faCogs,
  faCommentDots,
  faCreditCard,
  faDesktop,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpenText,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpandAlt,
  faEye,
  faFile,
  faFileImage,
  faFileAlt,
  faFileInvoice,
  faFileInvoiceDollar,
  faFolder,
  faFolderOpen,
  faGripHorizontal,
  faHandshake,
  faHashtag,
  faHdd,
  faHome,
  faIdBadge,
  faInfoCircle,
  faKey,
  faLanguage,
  faLink,
  faList,
  faListUl,
  faLock,
  faUnlock,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMap,
  faTable,
  faMicrophone,
  faMicrophoneSlash,
  faMinus,
  faMinusCircle,
  faNetworkWired,
  faMobile,
  faMoneyBillWaveAlt,
  faPaperPlane,
  faPen,
  faPencilAlt,
  faPercentage,
  faPhone,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faProjectDiagram,
  faQuestionCircle,
  faReceipt,
  faSearch,
  faShareAlt,
  faSignOutAlt,
  faSlidersH,
  faSave,
  faSpinner,
  faStream,
  faSync,
  faThLarge,
  faTimes,
  faTimesCircle,
  faTools,
  faTrash,
  faTrashAlt,
  faUndoAlt,
  faUnlink,
  faUpload,
  faFileUpload,
  faFileImport,
  faUser,
  faUserPlus,
  faUsers,
  faVideo,
  faVideoSlash,
  faDesktop,
  faArrowAltCircleDown,
  faArrowAltCircleUp,
  faStickyNote,
  faIndent,
  faOutdent,
  faCopy,
  faImage,
  faGavel,
  faUserTie,
  faFileSignature,
  faChartArea,
  faChartLine,
  faChartPie,
  faCalculator,
  faTicketAlt,
  faMoneyBill,
  faCoins,
  faPeopleArrows,
  faArrowAltCircleRight,
  faFileContract,
  faEyeSlash,
  faLandmark,
  faFolderMinus,
  faSignature,
  faFilePdf,
  faPaperclip,
  faUndo,
  faMoon,
  faSun
);
